<script setup>
import { useDisplay } from 'vuetify'
import { useAppStore } from '@/stores/App'

// Mobile breakpoint
const { xs } = useDisplay()

// App store
const app = useAppStore()
</script>

<template>
    <v-navigation-drawer
        id="thenavdrawer"
        v-if="xs && app.navDrawer"
        v-model="app.navDrawer"
        location="bottom"
        temporary
    >
        <v-list density="compact" nav>
            <v-list-item
                v-for="item in app.navbarItems"
                :key="item.title"
                :to="item.route"
                :prepend-icon="item.icon"
                :title="item.title"
                active-class="text-light-blue-darken-1"
            >
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<style scoped></style>
